import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { GitBranch, Sparkles, FileSignature, Pill, FlaskConical, Send } from "lucide-react";

export const Route = createFileRoute("/governance/workflows")({
  component: WorkflowsPage,
});

const WORKFLOWS = [
  {
    id: "wf-claim-submit",
    name: "Soumission feuille de soins",
    description: "Draft → Validation → Sign → Submit CNSS/CNOPS → Wait → Paid/Rejected",
    steps: ["draft", "validated", "signed", "submitted", "accepted", "paid"],
    status: "operational",
  },
  {
    id: "wf-prescription-dispense",
    name: "Prescription → Dispensation",
    description: "Signe par le médecin → Pharmacie reçoit → Vérification interactions → Dispensation",
    steps: ["signed", "received", "verified", "dispensed"],
    status: "operational",
  },
  {
    id: "wf-lab-order",
    name: "Lab order → Result",
    description: "Prescription labo → Prélèvement → Analyse → Validation biologiste → Publication",
    steps: ["ordered", "collected", "analyzed", "validated", "published"],
    status: "operational",
  },
  {
    id: "wf-ald-validation",
    name: "ALD demande → Validation",
    description: "Demande médecin → Contrôle médical CNOPS → Accord → Exonération",
    steps: ["requested", "reviewed", "approved", "exoneration_applied"],
    status: "operational",
  },
  {
    id: "wf-device-onboarding",
    name: "Onboarding dispositif",
    description: "Auto-detect → Profile match → IEC 62304 verification → Test connectivity → Activate",
    steps: ["detected", "profiled", "certified", "tested", "active"],
    status: "v7",
  },
];

function WorkflowsPage() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <GitBranch className="h-5 w-5" /> Workflows Saga
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Orchestration long-running · Compensations · Reprise sur erreur</p>
      </div>

      <div className="rounded-lg border border-indigo-500/30 bg-indigo-500/5 p-3 flex items-start gap-2 text-sm">
        <Sparkles className="h-4 w-4 text-indigo-400 mt-0.5" />
        <div><strong>v7.0</strong> · éditeur visuel de workflows. Pour l'instant, les sagas sont définies dans <code>packages/saga-engine</code>.</div>
      </div>

      <div className="space-y-2">
        {WORKFLOWS.map((wf) => (
          <Card key={wf.id}>
            <CardContent className="p-4">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <div className="font-medium">{wf.name}</div>
                  <div className="text-xs text-muted-foreground mt-0.5">{wf.description}</div>
                </div>
                <Badge variant={wf.status === "operational" ? "default" : "outline"} className="text-[10px]">
                  {wf.status}
                </Badge>
              </div>
              <div className="flex items-center gap-1 mt-3 overflow-x-auto">
                {wf.steps.map((s, i) => (
                  <>
                    <Badge key={s} variant="secondary" className="font-mono text-[11px] shrink-0">{s}</Badge>
                    {i < wf.steps.length - 1 && <span className="text-muted-foreground shrink-0">→</span>}
                  </>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
